import { PagedSoftwareSettingsMetadataList, SettingsTypeEnumSchema, SoftwareSettingsMetadata } from "@domain/schemas/BI";
import axios from "axios";
import { API_ENDPOINTS } from "@infrastructure/InfrastructureConstants";
import { ISoftwareSettingsRepository } from "@domain/repositories";
import { runtimeConfig } from "@utils/runtimeConfig/runtimeConfig";
import { inject, injectable } from "inversify";
import { TYPES } from "@utils/inversifyJS/types";
import type { IAuthenticatedRequestHandlerService } from "@application/contracts/services";
@injectable()
export class SoftwareSettingsRepository implements ISoftwareSettingsRepository {
  @inject(TYPES.IAuthenticatedRequestHandlerService)
  private _requestHandlerService!: IAuthenticatedRequestHandlerService;

  public async createAsync(settingsFile: File, softwareVersion: string, settingsType: SettingsTypeEnumSchema, onProgress: (progress: number) => void): Promise<SoftwareSettingsMetadata> {
    const formData = new FormData();
    formData.append("file", settingsFile);

    const url = `${runtimeConfig.API_BASE_URL}${API_ENDPOINTS.softwareSettingsUpload}`.replace("{version}", encodeURIComponent(softwareVersion)).replace("{type}", settingsType);

    return this._requestHandlerService.handleRequestAsync<SoftwareSettingsMetadata>(() =>
      axios.post<SoftwareSettingsMetadata>(url, formData, {
        onUploadProgress: (progressEvent) => {
          if (onProgress && progressEvent.total) {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            onProgress(percentCompleted);
          }
        },
      }),
    );
  }

  async GetListAsync(type: SettingsTypeEnumSchema): Promise<PagedSoftwareSettingsMetadataList> {
    const url = `${runtimeConfig.API_BASE_URL}${API_ENDPOINTS.softwareSettings}?type=${type}`;
    return this._requestHandlerService.handleRequestAsync<PagedSoftwareSettingsMetadataList>(() => axios.get<PagedSoftwareSettingsMetadataList>(url));
  }

  async deleteAsync(fileName: string, settingsType: SettingsTypeEnumSchema): Promise<boolean> {
    const url = `${runtimeConfig.API_BASE_URL}${API_ENDPOINTS.softwareSettings}`;
    return this._requestHandlerService.handleRequestAsync<boolean>(() =>
      axios.delete<boolean>(url, {
        params: {
          fileName: fileName,
          type: settingsType
        }
      })
    );
  }
}
